export const NEIGHBORHOOD_LANDING_PAGE_STRINGS = {
  'meta.title':
    '{neighborhoodName} {cityName} Property Management | Belong PRO',
  'meta.description':
    '{neighborhoodName} {city} rental home property management the way it should have been all along. Get guaranteed rent, lower vacancy, financing, and more with Belong PRO.',
  welcomeTitle: (neighborhoodName: string) => (
    <>
      <div>{"We'll find the perfect resident for your"}</div>
      <div>{neighborhoodName} home.</div>
    </>
  ),
  'meetTheTeam.title1':
    'Not\u00a0your\u00a0uncle’s property\u00a0management company.',
  'meetTheTeam.title2':
    'Meet our {cityName} Team in charge of {neighborhoodName}.',
  'meetTheTeam.text': (cityName: string) => (
    <>
      Our local team has{'\u00a0'}
      <b>
        over{'\u00a0'}40+{'\u00a0'}years of{'\u00a0'}real{'\u00a0'}estate
      </b>{' '}
      industry experience in{'\u00a0'}the{'\u00a0'}
      {cityName} Area.
    </>
  ),
  'valueProps.title': 'Why Choose Belong Over Property Management?',
  'valueProps.subtitle': 'Earn more. Stress less.',

  'neighborhoods.title':
    'We\u00a0proudly\u00a0serve\u00a0these {cityName} neighborhoods.',
  'neighborhoods.text':
    'So\u00a0they’ll\u00a0never\u00a0need\u00a0an\u00a0old-school\u00a0property\u00a0manager.',
  'neighborhoods.button.show': 'SHOW MORE',
  'neighborhoods.button.hide': 'SHOW LESS',

  'listings.title': (neighborhoodName: string) => (
    <>Belong Homes Near {neighborhoodName}</>
  ),

  'testimonials.title': 'No more landlords. No more tenants.',
  'testimonials.mobileTitle': "There's a lot of love to go around.",
  'testimonials.text': 'Just happy {cityName} Homeowners and Residents.',
  'video.testimonials.title':
    'From Property Management to Real Belonging: True Stories',

  'longTermSteps.title': () => (
    <>
      <div>
        Why{'\u00a0'}Choose Belong{'\u00a0'}over{'\u00a0'}a
      </div>
      <div>Property{'\u00a0'}Manager?</div>
    </>
  ),
  'longTermSteps.description': 'Earn more. Stress less.',

  'calculator.title': 'Get a feel for the guaranteed rent you’ll\u00a0earn...',

  'longTermSteps2.title': 'Quit\u00a0micromanaging your\u00a0property manager.',
  'longTermSteps2.text': 'Long-term\u00a0renting, made\u00a0lovable.',
  'priceTable.title': 'Pricing aligned with you.',
  'priceTable.subtitle': 'No gimmicks. Just\u00a0great\u00a0service.',
  'priceTable.showMore': 'Show More',
  'priceTable.showLess': 'Show Less',
  'imageBlock1.title': () => (
    <>
      <div>Maximize your long-term</div>
      <div>passive income with Belong.</div>
    </>
  ),
  'imageBlock1.description':
    'Maximize your returns for the year.\u00a0Long-term\u00a0leases from Belong offer stable income. Long periods of\u00a0vacancy do not.',
  'population.description': 'Population of {neighborhoodName}',
  'income.separator': '/ yr',
  'income.description': (neighborhoodName: string) => (
    <>
      <div>Median Household Income</div>
      <div>of {neighborhoodName}</div>
    </>
  ),
  'descriptionSection.title':
    '{neighborhoodName} deserves better\u00a0than old-school property\u00a0managers.',
  'blog.title': 'Read Our Blog',
  'blog.subtitle':
    'Your {neighborhoodName} guide to a post property managment world.',
  'blog.link': 'View All Articles',
};
